// extracted by mini-css-extract-plugin
export default {"loader":"InputLoader_loader__XyIYI","rotate":"InputLoader_rotate__7qswL"};